import axios from "axios";
import jsonFormData from "json-form-data";

const prepareData = (data) => {
	return jsonFormData({ project_twr: data }, { showLeafArrayIndexes: true });
};

// Plural Actions
export const GET_PROJECT_TWRS = "get_project_twrs";
export const getProjectTwrs = (project_id) => {
	const url = `/project/${project_id}/twrs.json`
	const request = axios.get(url);
	return {
		type: GET_PROJECT_TWRS,
		payload: request
	};
};


// Singular Actions
export const CREATE_PROJECT_TWR = "create_project_twr";
export const createProjectTwr = (project_id, data) => {
	const url = `/project/${project_id}/twrs.json`
	const request = axios({ method: "post", url: url, data: prepareData(data) });
	return {
		type: CREATE_PROJECT_TWR,
		payload: request
	};
};

export const GET_PROJECT_TWR = "get_project_twr";
export const getProjectTwr = (project_id, id) => {
	const url = `/project/${project_id}/twrs/${id}.json`
	const request = axios.get(url);
	return {
		type: GET_PROJECT_TWR,
		payload: request
	};
};

export const UPDATE_PROJECT_TWR = "update_project_twr";
export const updateProjectTwr = (project_id, id, data) => {
	const url = `/project/${project_id}/twrs/${id}.json`
	const request = axios({ method: "patch", url: url, data: prepareData(data) });
	return {
		type: UPDATE_PROJECT_TWR,
		payload: request
	};
};

export const DESTROY_PROJECT_TWR = "destroy_project_twr";
export const destroyProjectTwr = (project_id, id) => {
	const url = `/project/${project_id}/twrs/${id}.json`
	const request = axios({ method: "delete", url: url }); s
	return {
		type: DESTROY_PROJECT_TWR,
		payload: request
	};
};

export const DUPLICATE_PROJECT_TWR = "duplicate_project_twr";
export const duplicateProjectTwr = (project_id, id, new_project_id) => {
	const url = `/project/${project_id}/twrs/${id}/duplicate.json`
	const request = axios({
		method: "post", url: url, data: {
			new_project_id: new_project_id
		}
	});

	return {
		type: DUPLICATE_PROJECT_TWR,
		payload: request
	};
};
